import { TabId } from "@blueprintjs/core";
import React, { useCallback } from "react";

import { useOnClickProps } from "../../hooks/useOnClickProps.js";

import { HexTabLinkProps } from "./HexTabLink.js";
import { useInternalHexTab } from "./InternalHexTab.js";

interface InternalHexTabLinkProps extends HexTabLinkProps {
  onClick: (id: TabId, event: React.MouseEvent<HTMLElement>) => void;
  parentId: TabId;
  selected: boolean;
}

/**
 * @ignore
 * @private
 */
export const InternalHexTabLink = React.memo(function InternalHexTabLink(
  props: InternalHexTabLinkProps,
) {
  const {
    disabled,
    onClick: onClickProp,
    replace,
    target: targetProp,
    to,
    ...rest
  } = props;

  const {
    href,
    onClick: onLinkClick,
    target,
  } = useOnClickProps({ replace, target: targetProp, to });

  // combine prop's onClick with link's onClick since they have conflicting
  // signatures
  const onClick = useCallback(
    (id: TabId, event: React.MouseEvent<HTMLElement>) => {
      onClickProp(id, event);
      onLinkClick(event);
    },
    [onClickProp, onLinkClick],
  );

  const tabProps = useInternalHexTab<HTMLAnchorElement>({
    ...rest,
    onClick,
    disabled,
  });

  // anchor tags can't be disabled, so we omit the functional attributes
  if (disabled) {
    return <a {...tabProps} />;
  }

  return <a {...tabProps} href={href} target={target} />;
});
